// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"

// jQuery нужен Select2 — публикуем в window до его импорта.
import jquery from "jquery"
window.jQuery = jquery
window.$ = jquery

import select2 from "select2"
select2($)

import "./controllers"
import * as bootstrap from "bootstrap"
import "@oddcamp/cocoon-vanilla-js"
